/* Protection des images de la boutique : dissuade le copier-coller et l'enregistrement des visuels.
   - pas de menu contextuel (clic droit, appui long) sur les images et les galeries ;
   - pas de glisser-déposer d'image ;
   - raccourcis d'inspection et de code source bloqués (F12, Ctrl+Maj+I/J/C, Ctrl+U, Ctrl+S).
   Dissuasif seulement : un navigateur peut toujours être outillé pour récupérer une image affichée.
   Désactivable dans Paramètres du thème > Protection des images (jamais actif dans l'éditeur de thème). */
(function () {
  'use strict';

  var css = 'img, picture, video, canvas, .galerie-produit, .card__media, .media {' +
    '-webkit-user-drag: none; -webkit-touch-callout: none; user-select: none; -webkit-user-select: none; }';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var protege = function (el) {
    return el && el.closest && el.closest('img, picture, video, canvas, .galerie-produit, .card__media, .media, .product__media, [data-zoom-src]');
  };

  document.addEventListener('contextmenu', function (e) {
    if (protege(e.target)) { e.preventDefault(); }
  }, true);

  document.addEventListener('dragstart', function (e) {
    if (e.target && e.target.tagName === 'IMG') { e.preventDefault(); }
  }, true);

  document.addEventListener('keydown', function (e) {
    var k = (e.key || '').toLowerCase();
    var ctrl = e.ctrlKey || e.metaKey;
    var bloque = e.key === 'F12' ||
      (ctrl && e.shiftKey && (k === 'i' || k === 'j' || k === 'c')) ||
      (ctrl && (k === 'u' || k === 's'));
    if (bloque) {
      var t = e.target;
      var champ = t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable);
      if (!champ || k === 'u' || e.key === 'F12') { e.preventDefault(); e.stopPropagation(); }
    }
  }, true);
})();
